angular.module('homebot.directives')

  .directive('companyBranding', [function(){
    return {
      restrict: 'E',
      controllerAs: 'companyBrandingCtrl',
      bindToController: {
        office: '=',
      },
      scope: {},
      templateUrl: '/homes/templates/partials/company-branding.html',

      controller: function(){
        let ctrl = this;
      },
    }

  }]);
